import React, { useState } from 'react';

import './styles.css';

// import notificationServices from '../../../../services/academy/notificationServices';

// import compare from '../../../../functions/compare';

import { FaBell } from 'react-icons/fa';
// import ClassNotificationsCardItem from './ClassNotificationsCardItem';
import PopupNewNotification from './PopupNewNotification';
// import ActivityIndicator from '../../../../components/ActivityIndicator';

function ClassNotificationsCard(props) {
    const [popupNewNotificationVisible, setPopupNewNotificationVisible] = useState(false);
    // const [notifications, setNotifications] = useState([]);
    // const [numShowed, setNumShowed] = useState(3);
    // const [fetching, setFetching] = useState(true);

    // useEffect(() => {
    //     if (props.studentId)
    //         readNotifications();
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [props.studentId]);

    // async function readNotifications() {
    //     const response = await notificationServices.getStudentNotifications(props.studentId);
    //     setFetching(false);
    //     if (response.status === 200) {
    //         setNotifications(response.data
    //             .filter((item) => item.tipo === "Notificação Personalizada")
    //             .sort((a, b) => compare(`${a.data}T${a.hora}`, `${b.data}T${b.hora}`, true))
    //         );
    //     } else
    //         alert("Erro ao listar notificações, tente novamente!");
    // };
    
    // function showMoreNotifications() {
    //     if (numShowed + 3 >= notifications.length)
    //         setNumShowed(notifications.length);
    //     else
    //         setNumShowed(numShowed + 3);
    // }

    return (
        <div className='class-page-card' id='card-notifications'>
            <div className='class-card-notifications-header'>
                <h4><b><FaBell />Notificações</b></h4>
                {/* <span>{notifications.length} {notifications.length === 1 ? "notificação" : "notificações"}</span> */}
            </div>

            {/* {
                !fetching ? */}
                    <>
                        <button onClick={() => setPopupNewNotificationVisible(true)}>Enviar notificação</button>
                        <PopupNewNotification
                            visibility={popupNewNotificationVisible}
                            setVisibility={setPopupNewNotificationVisible}
                            classId={props.classId}
                            // onCreate={readNotifications}
                        />

                        {/* {
                            notifications.length ?
                                <>
                                    <ul className='class-card-notifications-list'>
                                        {
                                            notifications.slice(0, numShowed).map((item, index) =>
                                                <ClassNotificationsCardItem
                                                    key={item.id}
                                                    date={item.data.split('-').reverse().join('/')}
                                                    tittle={item.titulo}
                                                    content={item.conteudo}
                                                />
                                            )
                                        }
                                    </ul>
                                    {
                                        numShowed < notifications.length ?
                                            <button className='show-more' onClick={showMoreNotifications}>Exibir mais</button>
                                            : []
                                    }
                                </>
                                : []
                        } */}
                    </>
                    {/* : <ActivityIndicator />
            } */}
        </div>
    );
}

export default ClassNotificationsCard;